import React, { useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import { CloseButton, ModalContainer, Overlay } from "./styles";

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  closeOnOverlayClick?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  closeOnOverlayClick = false,
}) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [handleKeyDown]);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <Overlay onClick={handleOverlayClick} aria-modal="true" role="dialog">
      <ModalContainer>
        <CloseButton aria-label="Close modal" onClick={onClose}>
          &times;
        </CloseButton>
        {children}
      </ModalContainer>
    </Overlay>,
    document.body
  );
};
